import { Camera } from "@phosphor-icons/react";
import { useState } from "react";

import UploadAttachment from "common/components/UploadAttachment";
import { Button } from "common/components/ui/Button";
import WorkspaceImage from "common/components/WorkspaceImage";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useWorkspaceMutations from "common/datahooks/useWorkspaceMutations";

import SettingsItemContainer from "../SettingsItemContainer";

export default function WorkspacePicture() {
  const { id: workspaceId, icon_url } = useSelectedWorkspaceContext();
  const { updateWorkspaceImage, isUpdatingWorkspaceImage } =
    useWorkspaceMutations();
  const [fileErrorMessage, setFileErrorMessage] = useState(null);

  return (
    <SettingsItemContainer className="flex-col pb-5">
      <div className="flex items-center gap-x-2.5">
        <div className="relative">
          <WorkspaceImage id={workspaceId} size="lg" imageSrc={icon_url} />
          <UploadAttachment
            onFileUpload={(file) => {
              setFileErrorMessage(null);
              updateWorkspaceImage({ file, id: workspaceId });
            }}
            onFileUploadError={(_, errorMessage) => {
              setFileErrorMessage(errorMessage);
            }}
            currentFileCount={0}
            renderButton={(onClick) => (
              <Button
                size="xs"
                intent="iconOnly"
                className="absolute bottom-0 -right-0.5"
                onClick={onClick}
                isLoading={isUpdatingWorkspaceImage}
              >
                <Camera />
              </Button>
            )}
            allowedMimeTypes={["image/png", "image/jpeg"]}
            maxFiles={1}
            //10 mb file limit
            maxFileSize={10000000}
          />
        </div>
        <div className="flex flex-col gap-y-0.5">
          <span className="text-sm-bold">Workspace picture</span>
          <p className="text-xs-medium text-black-500">
            We only support PNG’s and JPG’s under 10MB
          </p>
        </div>
      </div>
      {fileErrorMessage && (
        <p className="text-red-500 text-xs mt-1">{fileErrorMessage}</p>
      )}
    </SettingsItemContainer>
  );
}
